'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MessageList = require('@/components/MessageList.vue');

var _MessageList2 = _interopRequireDefault(_MessageList);

var _MessageListMessageModern = require('@/customized-core/MessageListMessageModern.vue');

var _MessageListMessageModern2 = _interopRequireDefault(_MessageListMessageModern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_MessageList2.default],
    data: function data() {
        return {
            autoScrollFalseTime: null
        };
    },


    watch: {
        auto_scroll: function auto_scroll(newVal, oldVal) {
            if (!newVal) {
                this.autoScrollFalseTime = Date.now();
            } else {
                this.autoScrollFalseTime = null;
            }
        }
    },
    methods: {
        isRepeat: function isRepeat(_ref) {
            var message = _ref.message,
                idx = _ref.idx;

            var prevMessage = this.filteredMessages[idx - 1];

            return !!prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic';
        },
        isLast: function isLast(_ref2) {
            var message = _ref2.message,
                idx = _ref2.idx;

            if (this.filteredMessages.length === 1 || idx === this.filteredMessages.length - 1) {
                return true;
            }
            var nextMessage = this.filteredMessages[idx + 1];

            return !(nextMessage.nick === message.nick && nextMessage.time - message.time < 60000 && nextMessage.type !== 'traffic' && message.type !== 'traffic');
        },
        scrollToBottom: function scrollToBottom() {
            this.$el.scrollTop = this.$el.scrollHeight;
        },
        getUnreadMessages: function getUnreadMessages() {
            var _this = this;

            var gap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            return this.filteredMessages.filter(function (message) {
                return message.time > _this.buffer.last_read + gap;
            });
        },
        getQuantityUnreadMessages: function getQuantityUnreadMessages() {
            var unreadMessages = this.getUnreadMessages();
            return unreadMessages.length;
        },
        getQuantityLongAgoUnreadMessages: function getQuantityLongAgoUnreadMessages() {
            var unreadMessages = this.getUnreadMessages(5);
            return unreadMessages.length;
        },
        getUnreadMessagesIndicatorCount: function getUnreadMessagesIndicatorCount() {
            var _this2 = this;

            if (!this.autoScrollFalseTime) {
                return 0;
            }
            return this.filteredMessages.filter(function (message) {
                return message.time > _this2.autoScrollFalseTime;
            }).length;
        },
        shouldShowUnreadMarker: function shouldShowUnreadMarker(idx) {
            var network = this.buffer.getNetwork();

            var previous = this.filteredMessages[idx - 1];
            var current = this.filteredMessages[idx];

            if (network.nick === current.nick) {
                return false;
            }

            var lastRead = this.buffer.last_read;

            if (!lastRead) {
                return false;
            }

            if (previous && previous.time < lastRead && current.time > lastRead) {
                return true;
            }

            return false;
        }
    },
    components: {
        MessageListMessageModern: _MessageListMessageModern2.default
    },
    created: function created() {
        this.$emit('passML', this.thisMl);
        var self = this;
        this.listen(this.$state, 'url_visualisation.updated', function () {
            self.$refs.messagesList.scrollTo(0, self.$refs.messagesList.scrollHeight);
            return true;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/MessageList.vue
// module id = 1JvK
// module chunks = 1